module.exports = __webpack_public_path__ + "static/media/popup-button-x.e574ec94.svg";